import React, { Component } from 'react';

import { Polyline } from 'google-maps-react';



class SelectedOhls extends Component {


    componentDidMount() {
        this.loadSelectedOhls();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.selectedOHLs.length !== nextProps.selectedOHLs.length
            || this.props.zoomLevel !== nextProps.zoomLevel) {
            return true;
        }
        else {
            return false;
        }
    }

    componentDidUpdate() {
        this.loadSelectedOhls();
    }

    loadSelectedOhls = () => {
        let resultList = [];
        if (this.props.zoomLevel === 1) {
            resultList = this.props.selectedOHLs.map((ohl, index) =>
                <Polyline
                    key={ohl.name + String(index) + 'Selected'}
                    path={ohl.poles}
                    name={ohl.name}
                    strokeOpacity={0.4}
                    //onClick={this.props.selectedOHLs.length === 1 ? this.props.onOhlClick : this.props.onSegmentClick}
                    strokeColor={this.props.color110}
                    strokeWeight={10}
                    //icons={[{ icon: symbolOne, offset: '50%' }]}
                    ohls={this.props.selectedOHLs}
                />
            );
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }

    render() {
        return null;
    }
}


export default SelectedOhls;
